import React from 'react'
import logoSpotter from '../../images/login-spotter-logo.png'

// Define CSS styles as objects
const styles = {
  registrationMessage: {
    maxWidth: '500px',
    textAlign: 'justify',
  },
  introText: {
    marginBottom: '20px',
  },
  strongText: {
    fontWeight: 'bold',
  },
}

const daysOfWeek = [
  'Domingo',
  'Lunes',
  'Martes',
  'Miércoles',
  'Jueves',
  'Viernes',
  'Sábado',
]

const formatScheduleDays = (days) => {
  const selected = (days || '')
    .split('')
    .map((bit, index) => (bit === '1' ? daysOfWeek[index] : null))
    .filter(Boolean)
  if (selected.length <= 1) return selected[0] || ''
  return `${selected.slice(0, -1).join(', ')} y ${selected[selected.length - 1]}`
}

const formatTime = (isoString) =>
  new Date(isoString).toLocaleTimeString('es-UY', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'America/Montevideo',
  })

const formatDate = (isoString) =>
  new Date(isoString).toLocaleDateString('es-UY', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'America/Montevideo',
  })

const formatSchedule = ({ type, days, startTime, endTime }) => {
  const hours = `${formatTime(startTime)} y las ${formatTime(endTime)}`
  if (type === 'one_time') {
    const start = formatDate(startTime)
    const end = formatDate(endTime)
    return start === end
      ? `El ${start} entre las ${hours}`
      : `Desde el ${start} a las ${formatTime(startTime)} hasta el ${end} a las ${formatTime(endTime)}`
  }
  return `Todos los ${formatScheduleDays(days) || 'días'} entre las ${hours}`
}

const UserInvitationSuccess = ({ code, accessPin, schedules, isPermanent }) => {
  return (
    <div
      style={{
        justifyContent: 'center',
        fontSize: '20px',
        fontWeight: 'bold',
        color: 'white',
        height: '100%',
        minHeight: '90vh',
        padding: '100px 25px',
        display: 'flex',
      }}
    >
      <div style={styles.registrationMessage}>
        <img
          src={logoSpotter}
          style={{
            marginBottom: '20px',
            marginRight: '40px',
            marginTop: '20px',
          }}
          width="180px"
          alt="spotter"
        />
        {code && (
          <p style={styles.introText}>
            Para ingresar, introduce el siguiente código:{' '}
            <strong style={styles.strongText}>{code}</strong>
          </p>
        )}
        <p style={styles.introText}>
          Gracias por registrarte. Al llegar al edificio, puedes usar el
          reconocimiento facial en el portero.
        </p>
        {schedules && schedules.length > 0 && (
          <div style={styles.introText}>
            <p>Podrás ingresar:</p>
            <ul>
              {schedules.map((schedule) => (
                <li key={schedule.id}>{formatSchedule(schedule)}</li>
              ))}
            </ul>
          </div>
        )}
        {isPermanent && (
          <p style={styles.introText}>Tienes acceso todos los días.</p>
        )}
        {accessPin?.pin && (
          <p style={styles.introText}>
            Si el portero tiene solo un teclado numérico, también puedes
            ingresar el código: <strong style={styles.strongText}>{accessPin.pin}</strong>{' '}
            (digita *1*{accessPin.pin}#).
          </p>
        )}
      </div>
    </div>
  )
}
export default UserInvitationSuccess
